/**
 * Snap a coordinate to the pixel grid for crisp Canvas 2D rendering.
 *
 * Canvas strokes are centered on the path coordinate. A 1px-wide line at
 * y=100 spans y=99.5..100.5 and anti-aliases across two pixel rows.
 * Shifting to y=100.5 makes it span exactly 100..101 — one crisp row.
 *
 * Rule:
 *  - Odd  lineWidth → floor to int + 0.5  (e.g. 100.3 → 100.5, 100.8 → 100.5)
 *  - Even lineWidth → round to int        (e.g. 100.3 → 100, 100.8 → 101)
 */
export function snapToPixel(value: number, lineWidth: number): number {
    return lineWidth % 2 === 1 ? Math.floor(value) + 0.5 : Math.round(value);
}
